import { AutocompleteItem } from '@mantine/core';
import { Flow } from 'types';

export const recipientsValues = ['Athletes', 'Coaches', 'Staff'];

export const notificationTypeValues = ['Email', 'SMS'];

export type CardTypes =
  | 'trigger'
  | 'recipients'
  | 'notificationType'
  | 'notificationMessageTemplate'
  | 'delivery'
  | null;

export type TriggerTypes = 'immediateAndDelayed' | 'reminder' | null;

export interface NotificationMessageTemplateAutoCompleteValue extends AutocompleteItem {
  notificationMessageTemplateId: string;
  label: string;
}

export interface FormValues {
  flowId: string;
  name: string;
  trigger: Flow['trigger'] | null;
  recipients: Flow['recipients'] | null;
  notificationType: Flow['notificationType'] | null;
  notificationMessageTemplate: NotificationMessageTemplateAutoCompleteValue;
  enabled: boolean;
  deliveryMode: Flow['deliveryMode'];
  timeUnit: Flow['timeUnit'];
  timeAmount: Flow['timeAmount'];
  sendAtTime: Flow['sendAtTime'];
}
